import { module } from 'modujs';
import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';

export default class extends module {
    constructor(m) {
        super(m);

        this.length = this.$('item').length
        this.container = this.$('container')[0];
        this.pagination = this.$('pagination')[0]
    }

    init() {
        const args = {
            modules: [Pagination],
            speed: 700,
            loop: false,
            spaceBetween: 20,
            grabCursor: true,
            autoHeight: true,
            slidesPerView: 1.33,
            threshold: 3,
            resistance: false,
            pagination: {
                el: ".swiper-pagination",
                type: "progressbar",
            },
            breakpoints: {
                700: {
                    slidesPerView: 2.33,
                },
                1000: {
                    slidesPerView: 3.33,
                }
            }
        }

        // Init carousel only if it meets one of these condition
        if( this.length > 1) {
            this.carousel = new Swiper(this.container, args)
        } else {

        }
    }

    destroy() {
        super.destroy()
        this.carousel?.destroy(true, true)
    }
}
